/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  title: {
    id: "b2b.doplnkove-sluzby-grid.title",
    defaultMessage: "Supplementary services"
  },
  add: {
    id: "b2b.doplnkove-sluzby-grid.add",
    defaultMessage: "Add service"
  }
});

export default () => useMessages(MESSAGES);
